<template>
  <div class="bgBox">
    <div>HI，欢迎登录</div>
    <div class="last">达能业务管理平台</div>
    <img :src="logoURL" alt="homepage" />
  </div>
</template>

<script>
export default {
  name: "homepage",
  data() {
    return {
      logoURL: require("@/assets/homepage.png"),
    };
  },
};
</script>

<style scoped>
.bgBox {
  width: 100%;
  height: calc(100vh - 144px);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bgBox div {
  margin-top: 120px;
  height: 42px;
  font-size: 30px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.85);
  line-height: 44px;
}
.bgBox div.last {
  margin-top: 0;
  font-weight: bold;
  margin-bottom: 70px;
}
.bgBox img {
  width: 42%;
}
</style>



// WEBPACK FOOTER //
// src/views/homepage/homepage.vue